angular.module('lodash')
    .factory('_', () => window._ // Lodash must already be loaded on the page
);



// WEBPACK FOOTER //
// ./src/services/lodash.service.js